import { Asterisk } from "lucide-react";

const WORDS = ["Let's go insane", "Burning Fire", "Insane Heroes", "No boring feet"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-6 font-display text-5xl font-extrabold uppercase tracking-tight md:px-10 md:text-8xl ${i % 2 ? "text-stroke" : "text-ink"}`}>
          {w}
        </span>
        <Asterisk className="h-10 w-10 text-pink md:h-16 md:w-16" strokeWidth={3} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Sock styles" className="relative z-10 -my-4 overflow-hidden py-10">
    <div className="-rotate-2 bg-lime py-5 md:py-7">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);
